// Auth actions
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SET_NAME = "SET_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_EMAIL = "SET_EMAIL";
export const SET_CHANGE_EMAIL = "SET_CHANGE_EMAIL";
export const SET_PROFILE = "SET_PROFILE";
export const SET_COUNT = "SET_COUNT";
export const SET_ROLE = "SET_ROLE";
export const SET_USER_ID = "SET_USER_ID";
export const SET_USER = "SET_USER";
export const SET_TEAM_NAME = "SET_TEAM_NAME";

export const ADD_CART = "ADD_CART";
export const GET_CART = "GET_CART";

export const ADD_USER = "ADD_USER";
export const GET_USER = "GET_USER";
